export default function($) {

    "use strict";

    $('.c-home-slider').owlCarousel({
        loop:true,
        margin:10,
        nav:false,
        dots:true,
        items:1,
    });

    $('.c-products-slider').owlCarousel({
        nav:false,
        dots:true,
        items:1,
    });

}
